// Using custom alphabet to make IDs more readable
import { customAlphabet } from 'nanoid';

export const getCaseIdAlias = customAlphabet('0123456789ABCDEF', 8);
